// extracted by mini-css-extract-plugin
export default {"howWorks":"howworks_howWorks__E6ez6"};